import * as React from 'react';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import { Avatar, CircularProgress, Stack, Typography } from '@mui/material';
import { AdminMatchPlayerInfoDto, AdminMatchTeamInfoDto } from '../../models/dtos/AdminMatchStatDto';

export function PlayerAvatar(props: { player: AdminMatchPlayerInfoDto | null; size?: number }) {
    const { player, size = 32 } = props;

    return (
        <Avatar src={player?.imgUrl ?? undefined} sx={{ width: size, height: size }}>
            <PersonOutlineIcon fontSize="small" />
        </Avatar>
    );
}

export function TeamAvatar(props: { team: AdminMatchTeamInfoDto | null | undefined; size?: number }) {
    const { team, size = 28 } = props;

    return (
        <Avatar src={team?.photo_url ?? undefined} sx={{ width: size, height: size }}>
            {team?.name?.charAt(0) ?? '?'}
        </Avatar>
    );
}

export function CenteredProgress() {
    return (
        <Stack alignItems="center" justifyContent="center" sx={{ py: 4 }}>
            <CircularProgress size={28} />
        </Stack>
    );
}

export function EmptyState(props: { message: string }) {
    return (
        <Typography variant="body2" color="text.secondary" sx={{ py: 2 }}>
            {props.message}
        </Typography>
    );
}

export function formatLabel(value?: string | null) {
    if (value == null || value.length === 0) {
        return '-';
    }

    return value
        .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
        .replace(/_/g, ' ')
        .trim();
}

export function formatStatValue(value?: number | null) {
    if (value == null) {
        return '-';
    }

    if (Number.isInteger(value)) {
        return value.toString();
    }

    return value.toFixed(2).replace(/\.00$/, '');
}

export function parseNumberInput(value: string): number {
    if (value.trim().length === 0) {
        return 0;
    }

    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : 0;
}
